<div class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30"
    (click)="$event.preventDefault(); handleClose();">
    <div class="w-96 bg-white p-6 rounded-md shadow-lg text-center" (click)="$event.stopPropagation()">
        <form #newCustomPageForm="ngForm" (ngSubmit)="saveNewCustomPage()">
            <div class="w-full flex flex-row gap-8 items-center justify-between pb-4">
                <h2 class="w-full oswald-font text-xl font-medium text-start">
                    Add New Custom Page:
                </h2>
            </div>

            <div class="w-full h-full flex flex-col items-center gap-2 pb-4">
                <div class="w-full flex items-center text-start">
                    <div class="w-full flex flex-col items-center">
                        <input noEmoji type="text" name="newCustomPageTitle" [(ngModel)]="newCustomPageTitle" required
                            class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block p-2"
                            placeholder="Page Title" #newCustomPageTitleInput="ngModel">
                        <div class="w-full text-start italic text-xs text-red-500"
                            *ngIf="newCustomPageTitleInput.invalid && (newCustomPageTitleInput.dirty || newCustomPageTitleInput.touched)">
                            <div *ngIf="newCustomPageTitleInput.errors?.['required']">
                                This field is required.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full flex flex-row gap-2 items-center justify-end">
                <button class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    (click)="$event.preventDefault(); handleClose();">
                    Close
                </button>
                <button type="submit" [disabled]="newCustomPageForm.invalid"
                    class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                    [ngClass]="{
                        'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': newCustomPageForm.invalid,
                        'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': newCustomPageForm.valid
                    }">
                    Save
                </button>
            </div>
        </form>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>